import { useMutation } from '@tanstack/react-query';
import { deleteCustomerFile } from '../../services/customers';

interface Options {
  onSuccess?: (data: boolean) => void;
  onError?: (error: Error) => void;
  refetch?: () => unknown | Promise<unknown>;
}

function useDeleteCustomerFile({ onSuccess, onError, refetch }: Options = {}) {
  return useMutation({
    mutationFn: async (params: Parameters<typeof deleteCustomerFile>[0]) => {
      const result = await deleteCustomerFile(params);

      await refetch?.();

      return result;
    },
    onSuccess,
    onError,
  });
}

export default useDeleteCustomerFile;
